module.exports = require("./../../_gen/starling/text/ITextCompositor");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/ITextCompositor.js
// module id = 227
// module chunks = 0